import apiClient from './api';

// "Memoria" de proveedor -> categoría (endpoints/merchant_rules.py). Se
// crea/actualiza sola en el backend cada vez que se guarda una
// transacción con proveedor + categoría (manual o importada) — este
// servicio solo la lee, para sugerir proveedores ya conocidos y
// auto-completar la categoría en el frontend, y para borrar una
// asociación mal aprendida si hace falta.
const merchantRuleService = {
  getAll: async () => apiClient.get('/merchant-rules'),
  delete: async (id) => apiClient.delete(`/merchant-rules/${id}`),
};

export default merchantRuleService;
